export class Token {
    public values: any;
    public raw: string;

    constructor(urlStringified: string) {
        this.raw = urlStringified;
        this.values = {};

        if (this.raw) {
            let str = urlStringified
                .replace('_', '+')
                .replace('-', '/');

            if (str.length % 4 !== 0) {
                str = str.padEnd(str.length + 4 - (str.length % 4), '=')
            }

            this.values = JSON.parse(atob(str));
        }
    }

    get exp(): number {
        return Date.parse(this.values.exp) || Date.parse("1970-01-01T00:00:00Z");
    }
}